import { ProtectedRoute } from '@shared/auth';
import { Outlet } from 'react-router';

const MedicaidDatasetsLayout = () => {
  return <ProtectedRoute component={Outlet} policies={['isAnyArtiaUser']}/>;
};

export default MedicaidDatasetsLayout;
